import {useMemo} from 'react';
import {FlowEnum} from '../../booking/constants';
import {useGetCitiesQuery} from '../../city-selection/hooks/useGetCitiesQuery';
import {useGetLocalitiesQuery} from '../../booking/queries/useGetLocalitiesQuery';
import {UseGetRecentLocationParams} from './types';

export const useGetRecentLocation = ({
	flowType,
	cdUf,
	cdPlanoANSOdonto,
	nuRegistroPlano,
}: UseGetRecentLocationParams) => {
	const isHealthOrExamFlow = useMemo(
		() => [FlowEnum.HEALTH, FlowEnum.EXAM].includes(flowType),
		[flowType],
	);

	const shouldUseLocalitiesQuery = isHealthOrExamFlow && !!cdUf;
	const shouldUseCitiesQuery = !isHealthOrExamFlow && !!cdUf && !!flowType;

	const localitiesQuery = useGetLocalitiesQuery({
		flowType,
		stateCode: cdUf || '',
		enabled: shouldUseLocalitiesQuery,
	});

	const citiesQuery = useGetCitiesQuery({
		cdUf: cdUf || '',
		flowType,
		cdPlanoANSOdonto,
		nuRegistroPlano,
		enabled: shouldUseCitiesQuery,
	});

	if (shouldUseLocalitiesQuery) {
		return {
			...localitiesQuery,
			data: localitiesQuery.data || undefined,
		};
	}

	if (shouldUseCitiesQuery) {
		return {
			...citiesQuery,
			data: citiesQuery.data || undefined,
		};
	}

	return {
		data: undefined,
		isFetching: false,
		isLoading: false,
		error: null,
		isSuccess: false,
		isError: false,
	};
};
